import { LandingPage } from '../../../entity';
import {
  PageClassificationStrategy,
  PageClassificationStrategyBase,
} from '../pageClassificationStrategy';
import { AttributeTypeClassificationRule } from './rule';

class AttributeTypeClassificationStrategy
  extends PageClassificationStrategyBase
  implements PageClassificationStrategy
{
  private readonly attributeTypes: string[];

  constructor({
    attributeType,
    includeBreadcrumbs,
    omitStageAndSuppliers,
    pageType,
    pillars,
    template,
  }: AttributeTypeClassificationRule) {
    super(
      pageType,
      pillars,
      includeBreadcrumbs,
      undefined,
      omitStageAndSuppliers,
      template,
    );

    this.attributeTypes = Array.isArray(attributeType)
      ? attributeType
      : [attributeType];

    this.classify = this.classify.bind(this);
    this.strategyApplies = this.strategyApplies.bind(this);
  }

  classify(_page: LandingPage) {
    return this.withCommonValues({});
  }

  strategyApplies({ primaryAttribute }: LandingPage): boolean {
    if (!primaryAttribute) {
      return false;
    }

    return this.attributeTypes.includes(primaryAttribute.type);
  }
}

export { AttributeTypeClassificationStrategy };
